import { FC } from 'react';
import Image from 'react-bootstrap/Image';
import loader from 'assets/loader.svg';

export interface IProps {
  size?: 'small' | 'medium' | 'large';
}

const Loader: FC<IProps> = ({ size = 'medium' }: IProps) => {
  if (size === 'large')
    return (
      <Image
        width="50px"
        src={loader}
        alt="Loader"
      />
    );
  if (size === 'small')
    return (
      <Image
        width="20px"
        src={loader}
        alt="Loader"
      />
    );

  return (
    <Image
      width="35px"
      src={loader}
      alt="Loader"
    />
  );
};

export default Loader;
